import styled from 'styled-components';
import { ButtonMixin } from '../../mixins/components/ButtonMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledButton = /*#__PURE__*/styled.button.withConfig({
  shouldForwardProp: doNotForwardTransientProp(['loading'])
}).withConfig({
  displayName: "StyledButton",
  componentId: "c11n-8-111-1__sc-iv7357-0"
})(["", ""], ButtonMixin);